import { SVGInterface } from "../../interface";

const Wifi = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 10.675C10.9 10.675 10 11.575 10 12.675C10 13.775 10.9 14.675 12 14.675C13.1 14.675 14 13.775 14 12.675C14 11.575 13.1 10.675 12 10.675ZM18 12.675C18 9.36505 15.31 6.67505 12 6.67505C8.69 6.67505 6 9.36505 6 12.675C6 14.895 7.21 16.825 9 17.865L10 16.125C8.81 15.425 8 14.155 8 12.675C8 10.465 9.79 8.67505 12 8.67505C14.21 8.67505 16 10.465 16 12.675C16 14.155 15.19 15.425 14 16.125L15 17.865C16.79 16.825 18 14.895 18 12.675ZM12 2.67505C6.48 2.67505 2 7.15505 2 12.675C2 16.375 4.01 19.595 6.99 21.325L7.99 19.595C5.61 18.205 4 15.635 4 12.675C4 8.25505 7.58 4.67505 12 4.67505C16.42 4.67505 20 8.25505 20 12.675C20 15.635 18.39 18.205 16 19.595L17 21.325C19.99 19.595 22 16.375 22 12.675C22 7.15505 17.52 2.67505 12 2.67505Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Wifi;
